export default __webpack_public_path__ + "static/media/Gif_KaapseER.47614ed2.gif";